<template>
    <div class="menu-item-r">

        <div
            class="gPreReg"
            v-loading="loading"
        >
            <div style="margin-bottom:12px"  v-if="subjectType == 'VISITOR'">
                <el-button type="primary" size="small" @click="goPurchaseMeeting">
                    {{ $t('发布采购需求') }}
                </el-button>
            </div>
            <div v-if="subjectType === 'ACTOR'">
                <el-row
                    :gutter="20"
                    class="m-b-24"
                >
                    <el-col
                        :span="6"
                        class="m-r-10"
                    >
                        <el-input
                            prefix-icon="el-icon-search"
                            :placeholder="$t('procurement.pleaseEnter')"
                            size="small"
                            clearable
                            v-model="search.searchStr"
                        ></el-input>
                    </el-col>
                    <el-col
                        :span="9"
                        class="m-r-10"
                    >
                        <el-date-picker
                            style="margin-right:20px"
                            size="small"
                            v-model="dateTimeRange"
                            @change="selectTime"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :range-separator="$t('To')"
                            :start-placeholder="$t('procurement.procurementStartTime')"
                            :end-placeholder="$t('procurement.procurementEndTime')"
                        >
                        </el-date-picker>
                    </el-col>
                    <el-col
                        :span="3"
                        class="m-r-10"
                    >
                        <el-select
                            clearable
                            :placeholder="$t('procurement.status')"
                            size="small"
                            v-model="search.status"
                            class="v-select-height-32 m-l-0"
                            @change="selectChange(search.status,'auditStatus')"
                        >
                            <el-option
                                size="small"
                                v-for="(item, index) in auditStatusOption"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2">
                        <el-button
                            size="small"
                            type="primary"
                            @click="searchItem()"
                        >{{ $t('homes.searchPlaceHolder') }}
                        </el-button>
                    </el-col>
                </el-row>
            </div>

            <!-- 个人信息 -->
            <div class="body">
                <template v-if="subjectType === 'ACTOR'">
                    <el-table
                        :data="tableData"
                        border
                    >
                        <el-table-column
                            :label="$t('procurement.num')"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{ scope.row.sourcing['num'] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('procurement.title')"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{ scope.row.sourcing['title'] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('procurement.description')"
                            align="center"
                            width="250"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{ scope.row.sourcing['description'] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('procurement.startTime')"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{
                                        $funcs.dateFormat(scope.row.sourcing.startTime, 'YYYY-mm-dd HH:MM:SS')
                                                           }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('procurement.endTime')"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{
                                        $funcs.dateFormat(scope.row.sourcing.endTime, 'YYYY-mm-dd HH:MM:SS')
                                                           }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('procurement.place')"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{ scope.row.sourcing['place'] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('procurement.status')"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{ auditStatusConfig[scope.row['status']] }}</span>
                                <div
                                    v-if="scope.row['status'] === 'DISAPPROVE'"
                                    class="font-size-13 text-left reason"
                                >
                                    {{ $t('procurement.reason') }}: {{ scope.row['verifyDesc'] }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('procurement.createTimeActor')"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{
                                        $funcs.dateFormat(scope.row.createTime, 'YYYY-mm-dd HH:MM:SS')
                                                           }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('buttons.operation')"
                            align="center"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <!--v-if="subjectType !== 'ACTOR'"-->
                                <el-link
                                    v-if="scope.row['status'] === 'PENDING'"
                                    type="primary"
                                    class="color-blue m-r-10"
                                    @click="handleModify(scope.row.id)"
                                >{{ $t('修改') }}
                                </el-link>
                                <el-link
                                    type="primary"
                                    class="color-blue m-r-10"
                                    @click="delectItem(scope.row.id)"
                                >{{ $t('procurement.del') }}
                                </el-link>
                                <el-link
                                    type="primary"
                                    class="color-blue"
                                    @click="goDetails(scope.row.id)"
                                >{{ $t('procurement.details') }}
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template v-else>
                    <el-table
                        :data="tableData"
                        border
                    >
                        <el-table-column
                            :label="$t('procurement.name')"
                            align="center"
                            prop="name"
                            width="120"
                        ></el-table-column>
                        <el-table-column
                            :label="$t('procurement.companyName')"
                            align="center"
                            prop="companyName"
                        ></el-table-column>
                        <el-table-column
                            :label="$t('procurement.website')"
                            align="center"
                            prop="website"
                        ></el-table-column>
                        <el-table-column
                            :label="$t('procurement.email')"
                            align="center"
                            prop="email"
                        ></el-table-column>
                        <el-table-column
                            :label="$t('procurement.mobile')"
                            align="center"
                            prop="mobile"
                        ></el-table-column>
                        <el-table-column
                            :label="$t('procurement.createTime')"
                            align="center"
                            width="150"
                        >
                            <template slot-scope="scope">
                                <span class="font-size-13">{{
                                        $funcs.dateFormat(scope.row.createTime, 'YYYY-mm-dd HH:MM:SS')
                                                           }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            :label="$t('buttons.operation')"
                            align="center"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <el-link
                                    type="primary"
                                    class="color-blue m-r-10"
                                    @click="delectItem(scope.row.id)"
                                >{{ $t('procurement.del') }}
                                </el-link>
                                <el-link
                                    type="primary"
                                    class="color-blue"
                                    @click="goDetails(scope.row.id)"
                                >{{ $t('procurement.details') }}
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <div class="margin-t-24">
                    <el-pagination
                        v-if="tableData.length > 0"
                        background
                        @current-change="handleCurrentChange"
                        :page-size="query.pageRows"
                        :current-page.sync="query.pageNum"
                        layout="total, prev, pager, next, jumper"
                        :total="query.total"
                        class="bl-page"
                    >
                    </el-pagination>
                </div>
            </div>

            <winDialog
                v-if="dialogBadge"
                class="procurmentDialog"
                top="6vh"
                :dialogShow.sync="dialogBadge"
                :title="$t('procurement.Registration Info')"
                :showFooter="false"
            >
                <template v-slot:bodyContent>
                    <div v-if="subjectType === 'ACTOR'">
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.name"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.name') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.name }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.mobile"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.mobile') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.mobile }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.email"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.email') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.email }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.company"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.companyName') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.company }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.website"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.website') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.website }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.boothNum"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.boothNum') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.boothNum }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.description"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.description') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.description }}</h5>
                        </div>
                        <div
                            class="infoBoxImg"
                            v-if="detail.products"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.productImg') }}</p>
                            <div class="flex flex-start">
                                <img
                                    v-for="item in detail.products"
                                    :key="item.productId"
                                    v-lazy="$funcs.compressImage(item.productIcon, 160, 160)"
                                />
                            </div>
                        </div>

                    </div>
                    <div v-else>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.companyName"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.companyName') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.companyName }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.businessNature"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.businessNature') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.businessNature }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.email"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.email') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.email }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.website"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.website') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.website }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.name"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.name') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.name }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.answers"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.answers') }}</p>
                            <h5 class="infoBoxVal font-size-16">
                                <span
                                    class="theme-label"
                                    v-for="item in detail.answers"
                                    :key="item"
                                >
                                    {{ item.name }}
                                </span>
                            </h5>
                        </div>
                        <div
                            class="infoBoxImg"
                            v-if="detail.productImg"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.productImg') }}</p>
                            <div class="flex flex-start">
                                <img
                                    v-for="item in detail.productImg.split(',')"
                                    :key="item"
                                    v-lazy="$funcs.compressImage(item, 160, 160)"
                                />
                            </div>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.purchaseQuantity"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.purchaseQuantity') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.purchaseQuantity }}
                                                                {{ detail.unit || '' }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.suppliersBusinessNature"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{
                                    $t('procurement.suppliersBusinessNature')
                                                                            }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.suppliersBusinessNature }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.suppliersScale"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.suppliersScale') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.suppliersScale }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.suppliersRegion"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.suppliersRegion') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.suppliersRegion }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.other"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.other') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.other }}</h5>
                        </div>
                        <div
                            class="infoBox margin-b-8 p-8"
                            v-if="detail.expectedDate"
                        >
                            <p class="infoBoxLable font-size-14 margin-b-8">{{ $t('procurement.expectedDate') }}</p>
                            <h5 class="infoBoxVal font-size-16">{{ detail.expectedDate }}</h5>
                        </div>
                    </div>
                </template>
            </winDialog>

            <winDialog
                v-if="showModify"
                class="modifyDialog"
                top="6vh"
                :dialogShow.sync="showModify"
                :title="$t('修改')"
                :sure="handleSubmit"
            >
                <template #bodyContent>
                    <el-form
                        ref="form"
                        :model="form"
                        label-width="80px"
                        :rules="rules"
                        label-position="top"
                        size="small"
                    >
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <el-form-item
                                    prop="name"
                                    :label="`${$t('姓名')}：`"
                                >
                                    <el-input
                                        v-model="form.name"
                                        maxlength="50"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    prop="mobile"
                                    :label="`${$t('手机')}：`"
                                >
                                    <el-input
                                        v-model="form.mobile"
                                        maxlength="11"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    prop="email"
                                    :label="`${$t('邮箱')}：`"
                                >
                                    <el-input
                                        v-model="form.email"
                                        maxlength="100"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    prop="description"
                                    :label="`${$t('描述')}：`"
                                >
                                    <el-input
                                        v-model="form.description"
                                        maxlength="500"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    prop="boothNum"
                                    :label="`${$t('展位号')}：`"
                                >
                                    <el-input
                                        v-model="form.boothNum"
                                        maxlength="20"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    prop="website"
                                    :label="`${$t('网站')}：`"
                                >
                                    <el-input
                                        v-model="form.website"
                                        maxlength="100"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    prop="company"
                                    :label="`${$t('公司')}：`"
                                >
                                    <el-input
                                        v-model="form.company"
                                        maxlength="200"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item
                                    prop="productIds"
                                    :label="`${$t('展品')}：`"
                                >
                                    <div class="flex fs w100p mb20">
                                        <!-- <v-base-select
                                            v-model="form.productIds"
                                            type="hasList"
                                            width="300px"
                                            :data-list="productList"
                                            :placeholder="$t('请选择')"
                                            :label-key="'productName'"
                                            :value-key="'productId'"
                                            :multiple="true"
                                            :multiple-limit="3"
                                            @change="handleChangeProduct"
                                        /> -->
                                        <el-select v-model="form.productIds" :multiple="true" :multiple-limit="3" :placeholder="$t('请选择')">
                                          <el-option
                                              @change="handleChangeProduct"
                                              v-for="item in productList"
                                              :key="item.productId"
                                              :label="item.productName"
                                              :value="item.productId">
                                          </el-option>
                                      </el-select>
                                    </div>
                                    <el-row
                                        class="imgs flex as fs"
                                        :gutter="20"
                                    >
                                        <el-col
                                            v-for="(item,index) in productSelectItems"
                                            :key="index"
                                            :xl="8"
                                            :lg="8"
                                            :md="8"
                                            :sm="8"
                                            :xs="8"
                                        >
                                            <el-image
                                                v-if="item.productIcon"
                                                class="img-view"
                                                :src="item.productIcon"
                                                :fit="'fit'"
                                                :preview-src-list="item.productIcon.split(',')"
                                            />
                                            <el-image
                                                v-else-if="item.iconUrl"
                                                class="img-view"
                                                :src="item.iconUrl.split(',')[0]"
                                                :fit="'fit'"
                                                :preview-src-list="item.iconUrl.split(',')"
                                            />
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </template>
            </winDialog>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import winDialog from '@/components/Common/Dialog'
import {
    queryVisitorPage,
    queryVisitorDetail,
    deleteVisitorNeeds,
    queryExhibitorSignPage,
    getExhibitorSignDetail,
    getProductTagsList,
    updateProcurementDocking
} from '@/api/index'
// import BaseSelect from '../../components/Common/BaseSelect'

export default {
    name: 'procurementDocking',
    components: {
        winDialog,
        // 'v-base-select': BaseSelect
    },
    data() {
        return {
            loading: false,
            detail: {}, // 报名详情
            auditStatusOption: [
                {
                    value: 'PENDING',
                    label: this.$t('online.auditStatus[0]')
                },
                {
                    value: 'APPROVE',
                    label: this.$t('online.auditStatus[1]')
                },
                {
                    value: 'DISAPPROVE',
                    label: this.$t('online.auditStatus[2]')
                }
            ],
            auditStatusConfig: {
                'PENDING': this.$t('online.auditStatus[0]'),
                'APPROVE': this.$t('online.auditStatus[1]'),
                'DISAPPROVE': this.$t('online.auditStatus[2]')
            },
            search: {
                status: '',
                searchStr: '',
                startTime: '',
                endTime: ''
            },
            dateTimeRange: [],
            query: {
                pageNum: 1,
                pageRows: 10,
                total: 0
            },
            tableData: [], //列表数据
            dialogBadge: false, // dialog显示隐藏
            dialogBadgeTitle: '', // dialog标题
            dialogBadgeSubTitle: '', // dialog副标题
            showModify: false,
            productList: [],
            productSelectItems: [],
            form: {},
            rules: {
                name: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur',
                        regType: 'ExCnEnSpace'
                    }
                ],
                mobile: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur',
                        regType: 'ExPhone'
                    }
                ],
                email: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur',
                        regType: 'ExEmail'
                    }
                ],
                company: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                website: [
                    {
                        validator: this.validateRules,
                        required: false,
                        trigger: 'blur',
                        regType: 'ExDomain'
                    }
                ],
                boothNum: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'blur'
                    }
                ],
                description: [
                    {
                        validator: this.validateRules,
                        required: false,
                        trigger: 'blur'
                    }
                ],
                productIds: [
                    {
                        validator: this.validateRules,
                        required: true,
                        trigger: 'change',
                        regType: 'ExArray'
                    }
                ]
            }
        }
    },
    computed: {
        ...mapGetters([
            'info',
            'language',
            'subjectType'
        ])
    },
    mounted() {
        if (this.subjectType === 'ACTOR') {
            this.fetchActorDataList()
        } else {
            this.fetchDataList()
        }
    },
    methods: {
        goPurchaseMeeting() {
        // this.openNewPage(`${window.PC.$serverSetting['MAIN_APP_LICATION']}/${this.$store.getters.language === 'en' ? 'en' : 'cn'}/purchaseMeeting`, 'blank')
            this.$router.push('/purchaseMeeting')
        },
        initForm(id) {
            this.form = {
                id,
                sourcingId: undefined,
                name: undefined,
                mobile: undefined,
                email: undefined,
                description: undefined,
                boothNum: undefined,
                website: undefined,
                company: undefined,
                productIds: []
            }
        },
        searchItem() {
            if (this.dateTimeRange !== '' && this.dateTimeRange !== null) {
                this.search.startTime = this.dateTimeRange[0]
                this.search.endTime = this.dateTimeRange[1]
            } else {
                this.search.startTime = ''
                this.search.endTime = ''
            }
            this.fetchActorDataList()
        },
        selectTime() {
            if (this.dateTimeRange !== '' && this.dateTimeRange !== null) {
                this.search.startTime = this.dateTimeRange[0]
                this.search.endTime = this.dateTimeRange[1]
            } else {
                this.search.startTime = ''
                this.search.endTime = ''
                this.dateTimeRange = []
            }
        },
        // 获取展商列表
        fetchActorDataList() {
            // this.loading = true
            queryExhibitorSignPage({
                searchStr: this.search.searchStr || null,
                startTime: this.search.startTime || null,
                endTime: this.search.endTime || null,
                status: this.search.status || null,
                ...this.query
            }).then(res => {
                return res.data
            }).then(res => {
                this.tableData = res.data.list || []
                this.query.total = res.data.total || 0
                this.query.pages = res.data.pages || 0
            }).finally(() => {
                this.loading = false
            })
        },
        // 获取观众列表
        fetchDataList() {
            this.loading = true
            queryVisitorPage({
                ...this.query
            }).then(res => {
                return res.data
            }).then(res => {
                this.tableData = res.data.list || []
                this.query.total = res.data.total || 0
                this.query.pages = res.data.pages || 0
            }).finally(() => {
                this.loading = false
            })
        },
        // 页码 change
        handleCurrentChange(page) {
            this.query.pageNum = page
            if (this.subjectType === 'ACTOR') {
                this.fetchActorDataList()
            } else {
                this.fetchDataList()
            }
        },
        // 修改
        async handleModify(id) {
            this.initForm(id)
            await this.getDetails(id)
            this.showModify = true
        },
        // 删除
        delectItem(id) {
            this.$confirm(this.$t('procurement.Tips'), this.$t('tips'), {
                confirmButtonText: this.$t('ok'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteVisitorNeeds({
                    id
                }).then((res) => {
                    if (res.data.code === 1000) {
                        this.$message({
                            type: 'success',
                            message: this.$t('Delete completed')
                        })
                        if (this.subjectType === 'ACTOR') {
                            this.fetchActorDataList()
                        } else {
                            this.fetchDataList()
                        }
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: this.$t('procurement.Deletion cancelled')
                })
            })
        },
        // 获取观众详情
        async getVisitorDetail(id) {
            await queryVisitorDetail({
                id
            }).then(res => {
                return res.data
            }).then(res => {
                this.detail = this.form = res.data || {}
            })
        },
        // 获取展商详情
        async getActorDetail(id) {
            await getExhibitorSignDetail({
                id
            }).then(res => {
                return res.data
            }).then(res => {
                this.detail = this.form = res.data || {}
                this.productSelectItems = res.data.products
            })
        },
        // 查看详情
        goDetails(id) {
            this.dialogBadge = true
            this.getDetails(id)
        },
        // 获取详情
        async getDetails(id) {
            if (this.subjectType === 'ACTOR') {
                await this.getProductList()
                await this.getActorDetail(id)
            } else {
                await this.getVisitorDetail(id)
            }
        },
        // 更改产品
        handleChangeProduct(val) {
            this.productSelectItems = val
            this.form.productIds = val.map((v) => {
                return v.productId
            })
        },
        // 获取产品标签
        async getProductList() {
            this.loading = true

            const {data} = await getProductTagsList({
                pageRows: 9999,
                pageNum: 1,
                showType: 'PRODUCT_LIST',
                scopes: [
                    0,
                    2
                ]
            })
            if (data.code === 1000) {
                this.productList = data.data.list
            }

            this.loading = false
        },
        // 提交
        handleSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.loading = true
                    const {data} = await updateProcurementDocking(this.form)
                    if (data.code === 1000) {
                        this.showModify = false
                    }
                    this.loading = false
                }
            })
        }
    }
}
</script>

<style
    lang="stylus"
    scoped
>
.gPreReg {
    margin: 30px auto;
    padding: 24px 24px 70px;
    background: $color-gray-fb;

    .todo {
        margin-bottom: 24px;
        text-align: right;
    }

    >>> .el-table {
        .el-table__header-wrapper,
        .el-table__footer-wrapper {
            background: $color-gray-f1;
        }

        th {
            font-size: 14px;
            color: $color-gray-85;
            background: $color-gray-f1;
        }

        tr {
            background: $color-gray-fb;
        }
    }

    .card-img-box {
        position: relative;
        padding: 0;
        background: $color-vip-card__foot;
        color: $color-black;
        font-weight: 700;
        cursor: pointer;
        border: 1px solid $color-white;
        overflow: hidden;
        transition: all .3s;

        &:hover {
            border-color: $color-vip-card__foot;
        }

        .card-img__head {
            position: absolute;
            right: 6px;
            bottom: 33px;
            width: 44px;
            height: 56px;
            background: $color-gray-d9;
            object-fit: cover;
            z-index: 10
        }

        .card-userInfo {
            position: absolute;
            top: 22px;
            left: -23px;
            width: 150px;
            font-size: 12px;
            font-weight: 500;
            text-align: left;
            line-height: 1.4;
            transform: scale(0.6);
            color: $color-gray-65;
            z-index: 11;
        }

        .card-img-text {
            height: 22px;
            line-height: 22px;
        }

        .card-img-text2 {
            margin-left: -7px;
            white-space: nowrap;
            transform: scaleX(.8);
            font-size: 12px;
        }
    }
}


.procurmentDialog /deep/ .el-dialog__body {
    background: $color-gray-fb;
    height: 760px;
    overflow-y: auto
}

.procurmentDialog /deep/ .el-dialog__body {
    background: $color-gray-fb;
    /* max-height: 500px; */
    overflow-y: auto
}

.infoBox {
    background: $color-white;

    .infoBoxLable {
        color: $color-gray-45
    }

    .infoBoxVal {
        color: $color-gray-65
    }
}

.infoBoxImg {
    background: $color-white;
    margin-bottom:8px;
    padding:8px;
    .infoBoxLable {
        color: $color-gray-45;
        margin-bottom:8px;
    }
    img {
        width: 160px;
        height: 160px;
        margin-right: 24px
    }
}

.reason {
    color: $color-red
}

.label {
    .form-item-label {
    }

    .form-item-desc {
        font-size: 12px;
    }
}

.img-view {
    width: 100%;
    height: 200px;
}
</style>
